/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { mih_v1_auth_BankIDStart } from '../models/mih_v1_auth_BankIDStart';
import type { mih_v1_auth_BankIDStatus } from '../models/mih_v1_auth_BankIDStatus';
import type { mih_v1_auth_Login } from '../models/mih_v1_auth_Login';
import type { mih_v1_auth_SSEToken } from '../models/mih_v1_auth_SSEToken';
import type { mih_v1_auth_User } from '../models/mih_v1_auth_User';
import type { mih_v1_subscription_UserSubscription } from '../models/mih_v1_subscription_UserSubscription';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class DefaultService {
    /**
     * /mih/v1/auth/bank-id/start
     * @param requestBody
     * @returns mih_v1_auth_BankIDStart
     * @throws ApiError
     */
    public static postMihV1AuthBankIdStart(
        requestBody?: mih_v1_auth_BankIDStart,
    ): CancelablePromise<mih_v1_auth_BankIDStart> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mih/v1/auth/bank-id/start',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /mih/v1/auth/bank-id/status
     * @param requestBody
     * @returns mih_v1_auth_BankIDStatus
     * @throws ApiError
     */
    public static postMihV1AuthBankIdStatus(
        requestBody?: mih_v1_auth_BankIDStatus,
    ): CancelablePromise<mih_v1_auth_BankIDStatus> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mih/v1/auth/bank-id/status',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /mih/v1/auth/login
     * @param requestBody
     * @returns mih_v1_auth_Login
     * @throws ApiError
     */
    public static postMihV1AuthLogin(
        requestBody?: mih_v1_auth_Login,
    ): CancelablePromise<mih_v1_auth_Login> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mih/v1/auth/login',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * /mih/v1/auth/logout
     * @throws ApiError
     */
    public static postMihV1AuthLogout(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mih/v1/auth/logout',
        });
    }
    /**
     * /mih/v1/auth/sse-token
     * @returns mih_v1_auth_SSEToken
     * @throws ApiError
     */
    public static getMihV1AuthSseToken(): CancelablePromise<mih_v1_auth_SSEToken> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mih/v1/auth/sse-token',
        });
    }
    /**
     * /mih/v1/docs
     * @throws ApiError
     */
    public static getMihV1Docs(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mih/v1/docs',
        });
    }
    /**
     * /mih/v1/subscription/details
     * @returns mih_v1_subscription_UserSubscription
     * @throws ApiError
     */
    public static getMihV1SubscriptionDetails(): CancelablePromise<mih_v1_subscription_UserSubscription> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mih/v1/subscription/details',
        });
    }
    /**
     * /mih/v1/subscription/webhook
     * @throws ApiError
     */
    public static postMihV1SubscriptionWebhook(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/mih/v1/subscription/webhook',
        });
    }
    /**
     * /mih/v1/user/details
     * @returns mih_v1_auth_User
     * @throws ApiError
     */
    public static getMihV1UserDetails(): CancelablePromise<mih_v1_auth_User> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/mih/v1/user/details',
        });
    }
}
